import React, { createContext, useCallback, useContext, useState } from "react";
import ImportModal from "../../Components/Modal/ImportModal";

const ImportContext = createContext(null);

export const useImportModal = () => {
  const ctx = useContext(ImportContext);
  if (!ctx) {
    throw new Error("useImportModal must be used within <ImportProvider>");
  }
  return ctx;
};

export default function ImportProvider({ children }) {
  const [modalState, setModalState] = useState({
    isOpen: false,
    config: {},
  });

  const openImport = useCallback((config = {}) => {
    setModalState({ isOpen: true, config });
  }, []);

  const closeImport = useCallback(() => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  }, []);

  return (
    <ImportContext.Provider value={{ openImport, closeImport }}>
      {children}
      <ImportModal
        isOpen={modalState.isOpen}
        toggle={closeImport}
        config={modalState.config}
      />
    </ImportContext.Provider>
  );
}
